import { render, staticRenderFns } from "./communityAskList.vue?vue&type=template&id=107fb45d&scoped=true&"
import script from "./communityAskList.vue?vue&type=script&lang=js&"
export * from "./communityAskList.vue?vue&type=script&lang=js&"
import style0 from "./communityAskList.vue?vue&type=style&index=0&id=107fb45d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107fb45d",
  null
  
)

export default component.exports